// Angular
import { Routes } from '@angular/router';

// App components
import { MainLayoutComponent } from './layouts/main-layout/main-layout.component';

// App guards
import { bootstrapGuard } from '@app/core/guards/bootstrap.guard';


/**
 * Route Order Matters:
 * 1. Independent routes ('auth'): Placed first for performance. The router finds them immediately.
 * 2. Main Layout (path: ''): Placed next. Since every URL starts with an empty string,
 *    placing 'auth' below this would force the router to check all layout children first.
 * 3. Wildcard ('**'): Placed at the very bottom to catch unmatched URLs.
 */
export const routes: Routes = [
  {
    path: 'auth',
    loadChildren: () => import('./features/auth/auth.routes').then(m => m.routes)
  },
  {
    path: '',
    component: MainLayoutComponent,
    canActivate: [bootstrapGuard],
    children: [
      {
        path: '',
        redirectTo: 'dashboard',
        pathMatch: 'full'
      },
      {
        path: 'dashboard',
        loadComponent: () => import('./features/dashboard/dashboard.component').then(m => m.DashboardComponent)
      },
      {
        path: 'registration',
        loadChildren: () => import('./features/registration/registration.routes').then(m => m.routes)
      },
      {
        path: 'messages',
        loadChildren: () => import('./features/messages/messages.routes').then(m => m.routes)
      },
      {
        path: 'support',
        loadChildren: () => import('./features/support/support.routes').then(m => m.routes)
      },
      {
        path: 'profile',
        loadChildren: () => import('./features/profile/profile.routes').then(m => m.routes)
      },
      {
        path: 'developers',
        loadChildren: () => import('./features/developers/developers.routes').then(m => m.routes)
      },
      {
        path: 'sms-tools',
        loadChildren: () => import('./features/sms-tools/sms-tools.routes').then(m => m.routes)
      },
      {
        path: 'billing',
        loadChildren: () => import('./features/billing/billing.routes').then(m => m.routes)
      }
    ]
  },
  {
    component: MainLayoutComponent,
    path: '404'
  },
  {
    path: '**',
    redirectTo: '/404'
  }
];

